/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
//import './dawn';
console.log("Hello from above-fold.js");
console.log("No minify?");
})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

/******/ })()
;

var enterKeyCode = 13;
var spaceKeyCode = 32;
var leftKeyCode = 37;
var rightKeyCode = 39;
var downKeyCode = 40;
var upKeyCode = 38;
var escapeCode = 27;
var tabKeyCode = 9;
function escapeMenu(event) {
	var menu_checkbox = document.querySelector("#shop");
	if( event.keyCode == escapeCode ) {
		menu_checkbox.checked = false;
		event.preventDefault();
		document.removeEventListener("keydown",escapeMenu);
	} else if( event.keyCode == tabKeyCode ) {
		event.preventDefault();
		var menu_link = document.querySelector("label[for='shop']")
		menu_link.focus();
		menu_checkbox.checked = false;
		document.removeEventListener("keydown",escapeMenu);
	}
}
		function focusNext(el) {
				if(el.closest("li").nextElementSibling) {
					var next_choice = el.closest("li").nextElementSibling.querySelector("label")
					if(next_choice == null) {
						next_choice = el.closest("li").nextElementSibling.querySelector("a");
					}
					next_choice.focus();
				}
		}
		function focusPrev(el) {
			if(el.closest("li").previousElementSibling) {
				var prev_choice = el.closest("li").previousElementSibling.querySelector("label");
				if(prev_choice == null) {
					prev_choice = el.closest("li").previousElementSibling.querySelector("a");
				}
				prev_choice.focus();
			}
		}
document.addEventListener("DOMContentLoaded",function(e) {

	document.querySelectorAll("#shop, .open_submenu").forEach(function(menu) {
		console.log('DOMContentLoaded from above-fold');
		var menu_id = menu.getAttribute('id');

		var menu_toggle_selector = "label[for='"+menu_id+"']";
		var menuToggles = document.querySelectorAll(menu_toggle_selector);
		function escapeLocalMenu(event) {
			
			if(event.keyCode == leftKeyCode) {
				event.preventDefault();
				console.log("escapeLocalMenu!");
				menu.checked = false;
				document.removeEventListener("keydown",escapeLocalMenu);
				menuToggles[0].focus();
			}
		}

		menuToggles.forEach(function(menuToggle) {
			menuToggle.addEventListener("keydown", function(event) {
				arrowtrigger = downKeyCode;
				var for_id = this.getAttribute('for');
				if(for_id != "shop") {
					arrowtrigger = rightKeyCode;
				}
			    if(event.keyCode == enterKeyCode || event.keyCode == spaceKeyCode || event.keyCode == arrowtrigger) {
			    	event.preventDefault();
			        var menuOpen = menu.checked;
					var submenu_id = "#submenu-"+for_id;
					var $submenu_el = document.querySelector(submenu_id);
					var $focus_me = $submenu_el.querySelector("li.main-links:not(.return) > label, li.main-links:not(.return) > a");
			        if(menuOpen) {
			            menu.checked = false;
			            if(for_id == "shop") {
			            	document.removeEventListener("keydown",escapeMenu);
			            } else {
			            	document.removeEventListener("keydown",escapeLocalMenu);
			            }

			        } else {
			            menu.checked = true;
			            $focus_me.focus();
			            if(for_id == "shop") {
			            	document.addEventListener("keydown",escapeMenu);
			            } else {
			            	document.addEventListener("keydown",escapeLocalMenu);

			            }
			        }
			    } else if (event.keyCode == downKeyCode) {
			    	event.preventDefault();
			    	focusNext(menuToggle);
			    } else if (event.keyCode == upKeyCode) {
			    	event.preventDefault();
			    	focusPrev(menuToggle);

			    }
			});
		});

		menu.addEventListener('change', function(event) {
	        var menuOpen = menu.checked;
	        if(menuOpen) {
	   			menuToggles.forEach(function(menuToggle) {
	   				menuToggle.setAttribute("aria-expanded", true);
	   				menuToggle.setAttribute("aria-pressed", true);

	   			});
	        } else {
	   			menuToggles.forEach(function(menuToggle) {
	   				menuToggle.setAttribute("aria-expanded", false);
	   				menuToggle.setAttribute("aria-pressed", false);
	   			});
	        }
		});
	});
	document.querySelectorAll(".main-links a").forEach(function(main_link) {
			main_link.addEventListener("keydown", function(event) {
				if (event.keyCode == downKeyCode) {
			    	event.preventDefault();
			    	focusNext(main_link);
			    } else if (event.keyCode == upKeyCode) {
			    	event.preventDefault();
			    	focusPrev(main_link);

			    }
			});
	});
	document.querySelectorAll("#mazer-variant-picker label").forEach(function(label) {
		label.addEventListener('keydown',function() {
			if(event.keyCode == enterKeyCode || event.keyCode == spaceKeyCode) {
				var for_id = this.getAttribute('for');
				var this_input = document.querySelector("#"+for_id);
				//this_input.checked = this_input.checked ? false : true;
				this_input.click();
			} else if(event.keyCode == leftKeyCode) {
				event.preventDefault();
		    	if(label.closest("modal-opener").previousElementSibling) {
		    		var prev_choice = label.closest("modal-opener").previousElementSibling.querySelector("label");
		    		prev_choice.focus();
		    	}
			} else if(event.keyCode == rightKeyCode) {
				event.preventDefault();
		    	if(label.closest("modal-opener").nextElementSibling) {
		    		var next_choice = label.closest("modal-opener").nextElementSibling.querySelector("label");
		    		next_choice.focus();
		    	}
			}
		});
	});
    registerColinAccordion();
});


const acc_open_event = new Event("accordion_open");
const acc_close_event = new Event("accordion_close");

function toggleItem(e) {

            if(e.currentTarget.classList.contains('active') ) {
            	console.log("close")
                e.currentTarget.classList.remove('active');
                e.currentTarget.dispatchEvent(acc_close_event);
            } else {
				if(e.currentTarget.classList.contains("close-others")) {
					console.log("close-others!");

					let parentAccordion = e.currentTarget.closest("ul");
					if(parentAccordion) {
						(parentAccordion.querySelectorAll("ul > li > .key") || [] ).forEach(function($el) {
							$el.classList.remove('active');
						});
					} else {
						console.log("no parentAccordion found");
					}

				}
            	console.log("open");
                e.currentTarget.classList.add('active');
                e.currentTarget.dispatchEvent(acc_open_event);

            }
}

function registerColinAccordion() {
	(document.querySelectorAll(".colin-accordion > ul > li > .key") || []).forEach(function($el) {
		$el.removeEventListener("click",toggleItem);
        $el.addEventListener('click',toggleItem);
    });
}